  // JavaScript for pagination
  const products = document.querySelectorAll('.cardWrapper');
  const prevButton = document.getElementById('prevPage');
  const nextButton = document.getElementById('nextPage');
  const pageNumbersContainer = document.getElementById('pageNumbers');
  let currentPage = 1;
  const itemsPerPage = 18;

  function showPage(page) {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = page * itemsPerPage;

    products.forEach((product, index) => {
      if (index >= startIndex && index < endIndex) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  }

  function goToPage(page) {
    currentPage = page;
    showPage(currentPage);
    updatePaginationButtons();
  }

  function updatePaginationButtons() {
    const totalPages = Math.ceil(products.length / itemsPerPage);
    let pageNumbersHTML = '';

    pageNumbersHTML += `<button class="pageNumber${currentPage === 1 ? ' active' : ''}" onclick="goToPage(1)">1</button>`;


    if (currentPage > 3) {
      pageNumbersHTML += `<span class="dots">...</span>`;
    }

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
      if (i > 1 && i < totalPages) {
        if (i === currentPage) {
          pageNumbersHTML += `<button class="pageNumber active" onclick="goToPage(${i})">${i}</button>`;
        } else {
          pageNumbersHTML += `<button class="pageNumber" onclick="goToPage(${i})">${i}</button>`;
        }
      }
    }

    if (currentPage < totalPages - 2) {
      pageNumbersHTML += `<span class="dots">...</span>`;
    }
    pageNumbersHTML += `<button class="pageNumber${currentPage === totalPages ? ' active' : ''}" onclick="goToPage(${totalPages})">${totalPages}</button>`;

    pageNumbersContainer.innerHTML = pageNumbersHTML;
  }

  function goToPreviousPage() {
    if (currentPage > 1) {
      currentPage--;
      showPage(currentPage);
      updatePaginationButtons();
    }
  }

  function goToNextPage() {
    const totalPages = Math.ceil(products.length / itemsPerPage);
    if (currentPage < totalPages) {
      currentPage++;
      showPage(currentPage);
      updatePaginationButtons();
    }
  }

  prevButton.addEventListener('click', goToPreviousPage);
  nextButton.addEventListener('click', goToNextPage);

  showPage(currentPage);
  updatePaginationButtons();